
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Position extends Vue {
  @Prop(Function) changeSelect!: any;
  @Prop(Function) addWord!: any;
  @Prop(String) position_word!: string;
  optionsArea = [];
  searches = [];
  selected = "";

  async mounted() {
    const response = await (this as any).$root._get("area", {});
    (this as any).optionsArea = response.data.map((item: any) => {
      return { name: item.description, value: item.id };
    });
    if ((this as any).$store.state.token) {
      (this as any).$root.$on("bv::dropdown::show", (bvEvent: any) => {
        (this as any).loadSearches();
      });
      await (this as any).loadSearches();
    }
  }

  async loadSearches() {
    (this as any).searches = (
      await (this as any).$root._get("usersearch", {})
    ).data;
  }

  get wordPosition() {
    return (this as any).position_word;
  }

  set wordPosition(_) {}
}
